import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, EXPORT_FILE_NAME } from './constants';

class AdvancePaymentProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async GetAdvancePayment(parameters: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetAdvancePaymentReport?${parameters}&IsExport=${true}&ColumnSequence=${columnsSeq}`, EXPORT_FILE_NAME);
	}
}
export const apiProvider = new AdvancePaymentProvider();
